import { selectFormById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"

import { appStore } from "../../../../../../../../store"
import { formSettingsIdentifiersViewStaticData } from "../../../../../../../../views/FormSettingsIdentifiersView/constants"
import { FormSettingsIdentifiersView } from "../../../../../../../../views/FormSettingsIdentifiersView/FormSettingsIdentifiersView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers")({
	component: FormSettingsIdentifiersView,
	staticData: formSettingsIdentifiersViewStaticData,
	loader: ({ params }) => {
		const form = selectFormById(params.formId)(appStore.getState())
		if (!form) throw notFound()
	},
})
